import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button, Form } from "react-bootstrap";

export default function AddTestProfile({ handleClose, data }) {
    const { t } = useTranslation()
    const [testProfileName, setTestProfileName] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = () => {
        if (!testProfileName.trim()) {
            setError(t("Please enter test profile name"));
            return;
        }

        // If valid
        console.log("Test Profile Name:", testProfileName);
        setError("");
        handleClose();
    };

    useEffect(() => {
        if (data) {
            setTestProfileName(data.name)
        }
    }, [data])
    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>{data ? t("Edit Lab Report Test Profile") : t("Add Lab Report Test Profile")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="testProfileName">
                        <Form.Label>{t("Test Profile Name")}</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("Enter test profile name")}
                            value={testProfileName}
                            onChange={(e) => {
                                setTestProfileName(e.target.value);
                                setError("");
                            }}
                            isInvalid={!!error}
                        />
                        {error && (
                            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleSubmit}>
                    {data ? t("Update") : t("Create")}
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>

            </Modal.Footer>
        </>
    )
}
